<template>
  <button class="sn-tg" :class="{ 'sn-tg--off': getSoundIsMuted }" @click="toggleSound">
    <span class="sn-tg__inner">
      <img
        class="sn-tg__icon sn-tg__icon--on"
        src="../assets/img/shared/sound-on.svg"
        alt="Sound on icon"
      />

      <img
        class="sn-tg__icon sn-tg__icon--off"
        src="../assets/img/shared/sound-off.svg"
        alt="Sound off icon"
      />
    </span>
  </button>
</template>

<script>
  import { mapGetters } from 'vuex';
  import sound from '../services/sound';

  export default {
    computed: {
      ...mapGetters('layout', ['getSoundIsMuted']),
    },
    methods: {
      toggleSound() {
        this.$store.dispatch('layout/applySoundIsMuted', !this.getSoundIsMuted);

        if (!this.getSoundIsMuted) {
          sound.play('message');
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .sn-tg {
    border: none;
    background: none;
    padding: 16px;

    &__inner {
      position: relative;
      display: block;
      width: 24px;
      height: 24px;
      margin-top: -3px;
    }

    &__icon {
      width: 100%;
      height: 100%;
      //
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      &--off {
        opacity: 0;
      }

      &--on {
        opacity: 1;
      }
    }

    &--off &__icon--off {
      opacity: 1;
    }

    &--off &__icon--on {
      opacity: 0;
    }
  }
</style>
